<!--
  SelectedWhereaboutsInfoDialog.vue

  @remark Monitor Only
-->

<!-- -------------------------------------------------------------------------------- -->
<!-- template -->
<template>
  <div>
  <v-dialog
    v-model="mVisible"
    max-width="700px"
  >

    <div class="hm-swid">

    <div class="hm-swid-closebtn">
      <v-btn flat icon color="primary" @click="hide" class="ma-0">
        <v-icon>close</v-icon>
      </v-btn>
    </div>
      <!-- update時(データ送信時)に通知を受け取る -->
      <selected-whereabouts ref="selectedWhereabouts" @updateWhereaboutsInfo="onUpdateWhereaboutsInfo" />

    </div>
  </v-dialog>
  </div>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import SelectedWhereaboutsInfo from '@/components/SelectedWhereaboutsInfo'

export default {
  name: 'SelectedWhereaboutsInfoDialog',
  data: () => ({
    mVisible: false,
  }),
  components: {
    'selected-whereabouts': SelectedWhereaboutsInfo,
  },
  mounted: function () {
    this.$log.debug('# SelectedWhereaboutsInfoDialog')
    this.$on('show', this.show)
  },
  destroyed: function () {
    this.$log.debug('# SelectedWhereaboutsInfoDialog')
  },
  watch: {
    mVisible: function (current, previous) {
      // dialog close時のアクション
      if (current === false) {
        this.$store.dispatch('aSelectUser', null)
        this.$store.commit('setUpbtnVisible', false)
      }
    },
  },
  computed: {
  },
  methods: {
    // -------------------------------------------------------------------------
    onUpdateWhereaboutsInfo: function () {
      // 親(WhereaboutsList.vue)へデータを送信する
      this.$emit('updateWhereaboutsInfo')
      // 送信後はDialogを閉じる(操作性がよいため)
      this.hide()
    },
    show: function () {
      this.mVisible = true
    },
    hide: function () {
      this.mVisible = false
    },
  }
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-swid {
  /*padding-top: 15px;*/
  padding-bottom: 0px;
  background-color: whitesmoke;
}
.hm-swid-closebtn {
  height: 20px;
  text-align: right;
  background-color: whitesmoke;
}
</style>



// WEBPACK FOOTER //
// src/components/dialogs/SelectedWhereaboutsInfoDialog.vue